import { Box, CircularProgress } from '@mui/material';
import { useMaintenanceMode } from '../useMaintenanceMode';
import { MaintenanceStatus } from '../constants';
import { MaintenancePage } from '../MaintenancePage';

export const MaintenanceGate = ({ children }: { children: React.ReactNode }) => {
  const status = useMaintenanceMode();

  if (status === MaintenanceStatus.LOADING) {
    return (
      <Box
        sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (status === MaintenanceStatus.MAINTENANCE) {
    return <MaintenancePage />;
  }

  return <>{children}</>;
};
